import styled from '@emotion/styled';

import { BasicFlex } from '../Common';

import { IconButton } from '@mui/material';

import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';


const FileLabel = styled(BasicFlex)`
  width: fit-content;
  padding: 0.3rem .6rem;
  padding-right: .4rem;
  background-color: ${props => props.theme.colors.secondaryFaint};
  border: 1px solid ${props => props.theme.colors.secondary};
  border-radius: 5px;
  color: ${props => props.theme.colors.secondary};
  font-size: 1.2rem;
  cursor: pointer;
`;

const DeleteFile = styled.div`
  cursor: pointer;
  margin-left: 1rem;
`

const FileLabelComponent = ({ name, label, url, removeMedium }) => {
  return (
    <FileLabel key={name}>
      <AttachFileRoundedIcon fontSize="small" />
      <span>{label || name}</span>
      <DeleteFile onClick={(e) => {
          e.stopPropagation();
          removeMedium(name)
        }}>
        <IconButton size="small" ><HighlightOffRoundedIcon color="secondary" /></IconButton>
      </DeleteFile>
    </FileLabel>
  )
};

export default FileLabelComponent;